import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path data-name="Selection Control / Checkbox / Off / Disabled" d="M21.333 2.667v18.667H2.667V2.667zm0-2.667H2.667A2.674 2.674 0 000 2.667v18.667A2.675 2.675 0 002.667 24h18.666A2.675 2.675 0 0024 21.333V2.666A2.674 2.674 0 0021.333 0z" fill="#747474" opacity=".7" /></svg>);